import type { filterTypes } from './types';

export const haveDoesntHaveTypeValue: filterTypes[] = [
  { name: 'Known', value: 'does_have' },
  { name: 'Unknown', value: 'doesnt_have' },
];

export const matchNotMatchTypeValues: filterTypes[] = [
  { name: 'Match', value: 'match' },
  { name: 'Not Match', value: 'not_match' },
];

export const knownTypeValues: filterTypes[] = [
  { name: 'Known', value: 'known' },
  { name: 'Unknown', value: 'unknown' },
];

export const beforeAfterBetweenTypeValues: filterTypes[] = [
  { name: 'Before', value: 'before' },
  { name: 'After', value: 'after' },
  { name: 'Between', value: 'between' },
];

export const aboveBelowRangeTypeValues: filterTypes[] = [
  { name: 'Above', value: 'above' },
  { name: 'Below', value: 'below' },
  { name: 'Between', value: 'range' },
];

export const containsTypeValues: filterTypes[] = [
  { name: 'Contains exact', value: 'contains' },
  { name: 'Does not contain', value: 'not_contains' },
];

export const defaultFilterValues = {
  applied: false,
  valueToApply: '',
  filterValue: '',
  selectedType: { name: '', value: '' },
};
